import { init, thumbnailDecorator } from '@nosto/preact'
import { Serp, Category, Autocomplete, History } from './components'
import { defaultConfig } from './config'

import './styles/index.css'

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    // historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: '.site-header__search-input',
    contentCssSelector: '#MainContent',
    formCssSelector: '#search-form',
    hitDecorators: [thumbnailDecorator({ size: '9' })],
    serpUrlMapping: {
        query: 'q',
        'products.filter': 'filter',
        'products.page': 'page',
        'products.sort': 'sort',
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    // serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    // serpPathRedirect: true,
    serpQuery: {
        products: {
            facets: ['*'],
            size: defaultConfig.serpSize,
            from: 0,
        },
    },
    autocompleteQuery: {
        products: {
            size: defaultConfig.autocompleteProductsSize,
        },
        keywords: {
            fields: ['keyword', '_highlight.keyword'],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ['*'],
        },
    },
    compressUrlParameters: true,
    fallback: true,
})
